import React, { useState, useRef, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import "../styles/Myquestion.css";
import { FaBell, FaUserCircle, FaTrash, FaEdit } from "react-icons/fa";
import axios from 'axios';
import { toast } from 'react-toastify';
const Myquestion = () => {
  const [activeItem, setActiveItem] = useState("/questions/myquestions");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedType, setSelectedType] = useState("mcq");
  const [showDropdown, setShowDropdown] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dropdownRef = useRef(null);

  const [questionData, setQuestionData] = useState({
    mcq: [],
    fill: [],
    truefalse: [],
    veryshort: [],
    short: [],
    long: [],
    matching: [],
    diagram: [],
  });
  const [dashboardData, setDashboardData] = useState({
    totalBoard: 0,
    totalGrade: 0,
    totalSubjects: 0,
    totalPapers: 0,
    totalQuestions: 0,
  });
  // Fetch dashboard & user data
  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get("https://digital.tifleducation.com/admin/public/api/getDashboard", {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (res.data) {
          setDashboardData({
            totalBoard: res.data.totalBoards || 0,
            totalGrade: res.data.totalGrades || 0,
            totalSubjects: res.data.totalSubjects || 0,
            totalPapers: res.data.totalPapers || 0,
            totalQuestions: res.data.totalQuestions || 0,
          });
          if (res.data.user) {
            setUser({
              id: res.data.user.id,
              name: res.data.user.name || '',
              email: res.data.user.email || '',
              password: '', // empty for editing
            });
          }
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error.response?.data || error);
      }
    };

    fetchDashboardData();
  }, []);
  // Handle save changes
  const handleSaveProfile = async () => {
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        "https://digital.tifleducation.com/admin/public/api/update-profile",
        {
          name: user.name,
          password: user.password,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.success("Profile updated successfully!");

      setIsModalOpen(false);
      setUser({ ...user, password: '' }); // reset password field
    } catch (error) {
      console.error("Error updating profile:", error.response?.data || error);

      toast.error("Failed to update profile");

    }
  };

  const [user, setUser] = useState({
    id: null,
    name: '',
    email: '',
    password: '',
  });
  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const token = localStorage.getItem("token");

  // ✅ Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const handleBulkDelete = async () => {
    if (!window.confirm("Are you sure you want to delete selected questions?")) return;

    try {
      for (let id of selectedQuestions) {
        await fetch(`https://digital.tifleducation.com/admin/public/api/delete-question/${id}`, {
          method: "DELETE",
          headers: { Authorization: `Bearer ${token}` },
        });
      }

      // Remove deleted questions from UI
      setQuestionData((prev) => ({
        ...prev,
        [selectedType]: prev[selectedType].filter((q) => !selectedQuestions.includes(q.id)),
      }));

      setSelectedQuestions([]);
    } catch (err) {
      console.error("❌ Bulk delete failed:", err);
   
      toast.error("Failed to delete. Try again..");
    }
  };

  // ✅ Fetch My Questions API
  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const res = await fetch("https://digital.tifleducation.com/admin/public/api/my-questions", {
          headers: { Authorization: `Bearer ${token}` },
        });
        const json = await res.json();

        if (!res.ok) throw new Error(json.message || "Failed to load questions");

        const questions = json.questions || json.data || json || [];

        const grouped = {
          mcq: [],
          fill: [],
          truefalse: [],
          veryshort: [],
          short: [],
          long: [],
          matching: [],
          diagram: [],
        };

        questions.forEach((q) => {
          switch (q.question_type) {
            case "M.C.Q":
              grouped.mcq.push({
                id: q.id,
                question: q.question_title,
                options: q.options || [],
              });
              break;
            case "Fill in the blanks":
              grouped.fill.push({ id: q.id, question: q.question_title, answer: q.answer_text });
              break;
            case "True-False":
              grouped.truefalse.push({ id: q.id, question: q.question_title });
              break;
            case "Very Short Question Answer":
              grouped.veryshort.push({ id: q.id, question: q.question_title, answer: q.answer_text });
              break;
            case "Short Question Answer":
              grouped.short.push({ id: q.id, question: q.question_title, answer: q.answer_text });
              break;
            case "Long Question Answer":
              grouped.long.push({ id: q.id, question: q.question_title, answer: q.answer_text });
              break;
            case "Diagram-Based_Image-Based Questions":
              grouped.diagram.push({ id: q.id, question: q.question_title, answer: q.answer_text });
              break;
            case "Matching Types":
              grouped.matching.push({
                id: q.id,
                question: q.question_title,
                left: q.left_column || "",
                right: q.right_column || "",
              });
              break;
            default:
              break;
          }
        });

        setQuestionData(grouped);
      } catch (err) {
        console.error("❌ Failed to fetch questions:", err);
      }
    };

    fetchQuestions();
  }, [token]);

  // ✅ Reset pagination when tab changes
  useEffect(() => {
    setCurrentPage(1);
  }, [selectedType]);

  // ✅ Checkbox Select All
  const handleSelectAll = () => {
    const currentQuestions = questionData[selectedType];
    if (selectedQuestions.length === currentQuestions.length) {
      setSelectedQuestions([]);
    } else {
      setSelectedQuestions(currentQuestions.map((q) => q.id));
    }
  };

  const handleCheckboxChange = (id) => {
    setSelectedQuestions((prev) =>
      prev.includes(id) ? prev.filter((qid) => qid !== id) : [...prev, id]
    );
  };

  const handleDelete = async (type, id) => {
    if (!window.confirm("Are you sure you want to delete this question?")) return;
    try {
      const res = await fetch(`https://digital.tifleducation.com/admin/public/api/delete-question/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error("Failed to delete");

      setQuestionData((prev) => ({
        ...prev,
        [type]: prev[type].filter((q) => q.id !== id),
      }));
    } catch (err) {
      console.error("❌ Delete failed:", err);
      
      toast.error("Failed to delete. Try again..");
    }
  };

  // Dropdown close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const questionTypes = [
    { key: "mcq", label: "M.C.Q" },
    { key: "fill", label: "Fill in the blank" },
    { key: "truefalse", label: "True - False" },
    { key: "veryshort", label: "Very Short Ans - Que." },
    { key: "short", label: "Short Ans - Que." },
    { key: "long", label: "Long Ans - Que." },
    { key: "matching", label: "Matching Type" },
    { key: "diagram", label: "Diagram/Image-based" },
  ];

  // ✅ Utility: clean <p> → <span>
  const cleanHTML = (html) =>
    html ? html.replace(/<p>/g, "<span>").replace(/<\/p>/g, "</span>") : "";

  // ✅ Pagination logic
  const currentQuestions = questionData[selectedType].slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const totalPages = Math.ceil(questionData[selectedType].length / itemsPerPage);


  return (
    <div className="dashboard-container">
      <Sidebar
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
      />

      <main className="main-content">
        <div className="myquestion-header">
          <div className="myquestion-welcome-text">
            <a href="/dashboard" className="back-link">
              <i className="fa fa-arrow-left" aria-hidden="true"></i>
            </a>
            <span className="myquestion-welcome-text">My Questions</span>
          </div>
          <div className="header-icons" ref={dropdownRef}>
            <FaBell className="icon" />
            <div className="user-dropdown-wrapper">
              <FaUserCircle className="icon" onClick={() => setShowDropdown((p) => !p)} />
              {showDropdown && (
                <div className="user-dropdown">
                  <div className='edituser' onClick={() => setIsModalOpen(true)}>
                    <FaUserCircle className="ditusericon" />
                    <span>Edit Profile</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="question-type-tabs">
          {questionTypes.map((type) => (
            <div
              key={type.key}
              className={`tab ${selectedType === type.key ? "active" : ""}`}
              onClick={() => {
                setSelectedType(type.key);
                setSelectedQuestions([]);
              }}
            >
              {type.label}
            </div>
          ))}
        </div>

        {/* Select All */}
        {/* <div className="myquedelete">
          <label>
            <input
              type="checkbox"
              checked={
                questionData[selectedType].length > 0 &&
                selectedQuestions.length === questionData[selectedType].length
              }
              onChange={handleSelectAll}
            />
            &nbsp;Select All
          </label>

          {selectedQuestions.length > 0 && (
            <button className="delete-all-btn" onClick={handleBulkDelete}>
              <FaTrash /> Delete Selected
            </button>
          )}
        </div> */}


        {/* Questions */}
        <div className="myquestion-content">
          {currentQuestions.length === 0 ? (
            <div className="no-data">
              <p>No data found</p>
            </div>
          ) : (
            currentQuestions.map((q, index) => {
              const cleanQuestion = cleanHTML(q.question);

              return (
                <div className="mymcq2-box" key={q.id}>
                  <div className="mycheckbox-line">
                    {/* <input
                      type="checkbox"
                      checked={selectedQuestions.includes(q.id)}
                      onChange={() => handleCheckboxChange(q.id)}
                    /> */}
                    <span
                      className="mymcq2-question"
                      dangerouslySetInnerHTML={{
                        __html: `${(currentPage - 1) * itemsPerPage + index + 1}. ${cleanQuestion}`,
                      }}
                    />
                    <a href={`/questions/queedit/${q.id}`}>
                      <FaEdit className="edit-icon" />
                    </a>
                    {/* <FaTrash
                      className="delete-icon"
                      onClick={() => handleDelete(selectedType, q.id)}
                    /> */}
                  </div>

                  {/* M.C.Q */}
                  {selectedType === "mcq" && (
                    <div className="row mcq2-options">
                      {q.options.map((opt, i) => {
                        const cleanOpt = cleanHTML(opt);
                        return (
                          <div key={i} className=" myqueoption col-md-3 d-flex">
                            <strong className="me-2">{String.fromCharCode(65 + i)}.</strong>
                            <span dangerouslySetInnerHTML={{ __html: cleanOpt }} className="myqueimgspan" />
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {/* True / False */}
                  {selectedType === "truefalse" && (
                    <div className="row mcq2-options">
                      <div className="col-md-3 d-flex">
                        <span>(True / False)</span>
                      </div>
                    </div>
                  )}

                  {/* Fill / Short / Diagram */}
                  {["fill", "short", "diagram"].includes(selectedType) && q.answer && (
                    <div
                      className="answer-text"
                      style={{ paddingLeft: 20, paddingRight: 20 }}
                      dangerouslySetInnerHTML={{ __html: cleanHTML(q.answer) }}
                    />
                  )}

                  {/* Matching */}
                  {selectedType === "matching" && (
                    <div className="row que-row">
                      <div className="col-6">
                        {q.left &&
                          q.left.split(/<\/p>/).map(
                            (left, i) =>
                              left.trim() !== "" && (
                                <div key={i} dangerouslySetInnerHTML={{ __html: left + "</p>" }} />
                              )
                          )}
                      </div>
                      <div className="col-6">
                        {q.right &&
                          q.right.split(/<\/p>/).map(
                            (right, i) =>
                              right.trim() !== "" && (
                                <div key={i} dangerouslySetInnerHTML={{ __html: right + "</p>" }} />
                              )
                          )}
                      </div>
                    </div>
                  )}
                </div>
              );
            })
          )}
        </div>

        {/* ✅ Pagination Controls */}
        <div className="pagination">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
          >
            Prev
          </button>

          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i}
              className={currentPage === i + 1 ? "active" : ""}
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </button>
          ))}

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
          >
            Next
          </button>
        </div>


      </main>
     {/* Profile Edit Modal */}
            {isModalOpen && (
                <div style={modalStyles.overlay}>
                    <div style={modalStyles.modal}>
                        <button style={modalStyles.closeBtn} onClick={() => setIsModalOpen(false)}>&times;</button>
                        <div style={modalStyles.userIcon}><FaUserCircle /></div>

                        <div style={modalStyles.formGroup}>
                            <label>Username</label>
                            <input
                                type="text"
                                value={user.name}
                                onChange={(e) => setUser({ ...user, name: e.target.value })}
                                style={modalStyles.input}
                            />
                        </div>

                        <div style={modalStyles.formGroup}>
                            <label>Email</label>
                            <input type="email" value={user.email} disabled style={{...modalStyles.input, background: '#f0f0f0', color:'#888'}} />
                        </div>

                        <div style={modalStyles.formGroup}>
                            <label>Password</label>
                            <input
                                type="password"
                                value={user.password}
                                onChange={(e) => setUser({ ...user, password: e.target.value })}
                                style={modalStyles.input}
                            />
                        </div>

                        <div style={{textAlign:'right'}}>
                            <button style={modalStyles.saveBtn} onClick={handleSaveProfile}>Save Changes</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

// Modal inline styles
const modalStyles = {
    overlay: {
        position: "fixed",
        top:0, left:0, width:"100%", height:"100%",
        background:"rgba(0,0,0,0.6)",
        display:"flex", justifyContent:"center", alignItems:"center", zIndex:1000
    },
    modal: {
        background:"#fff", padding:"2rem", borderRadius:"12px",
        width:"90%", maxWidth:"400px", position:"relative",
        boxShadow:"0 4px 15px rgba(0,0,0,0.2)"
    },
    closeBtn: {
        position:"absolute", top:"10px", right:"15px",
        background:"none", border:"none", fontSize:"1.5rem", cursor:"pointer"
    },
    userIcon: {
        textAlign:"center", fontSize:"4rem", color:"#129255", marginBottom:"1rem"
    },
    formGroup: { marginBottom:"1rem" },
    input: { width:"100%", padding:"0.5rem 0.8rem", borderRadius:"6px", border:"1px solid #ccc", outline:"none" },
    saveBtn: { background:"#129255", color:"#fff", border:"none", padding:"0.6rem 1.2rem", borderRadius:"6px", cursor:"pointer", fontWeight:"bold" }
};


export default Myquestion;
